import React, { ReactNode, useState } from 'react';
import { Flex, Icon, Box, SystemProps } from '@storyofams/react-ui';
import { AnimatePresence, m } from 'framer-motion';
import { Button } from '../Button';
import { Divider } from '../Divider';
import { Heading } from '../Heading';
import { Plus, Minus } from '../Icons';

interface AccordionProps extends SystemProps {
  title: string;
  children: ReactNode;
  icon?: 'chevron' | 'plus';
}

export const Accordion = ({
  title,
  children,
  icon = 'chevron',
  ...props
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Divider color="grey100" />

      <Flex justifyContent="space-between">
        <Button
          variant="unstyled"
          justifyContent="space-between"
          py={3}
          onClick={() => setIsOpen(!isOpen)}
          width="100%"
          maxHeight="62px"
          alignItems="center"
          pr={1.5}
          {...props}
        >
          <Heading variant="h4" as="h3" color={isOpen && 'primary'}>
            {title}
          </Heading>
          <Icon
            icon={isOpen ? Minus : Plus}
            fontSize={2.5}
            transition={`transform ${icon === 'plus' ? 0.1 : 0.2}s ease-in-out`}
          />
        </Button>
      </Flex>

      <AnimatePresence>
        {isOpen && (
          <m.div
            initial={{ opacity: 0, height: 0 }}
            exit={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'min-content' }}
            transition={{ ease: 'easeInOut', duration: 0.24 }}
          >
            <Box pb={props.py || props.pb || 3}>{children}</Box>
          </m.div>
        )}
      </AnimatePresence>
    </>
  );
};
